/**
 * @generated SignedSource<<6edde109cc4e63e83c93d7391c0ab91a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddToLibraryMenu_viewer$data = {
  readonly account: {
    readonly allowBotlessRecording: boolean;
    readonly billingAccount: {
      readonly subscriptionBillingCycleAnchor: string | null;
    };
    readonly uploadCredits: {
      readonly includedCreditsUsedCurrentCycle: number;
      readonly includedUploadCredits: number;
    };
  };
  readonly hasAccessToCopilot: boolean;
  readonly remainingMeetingRecordingCredits: number;
  readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer" | "EventFormModal_viewer" | "UploadMenuItem_viewer" | "featureFlag_useCopilotPaywallsOn_viewer">;
  readonly " $fragmentType": "AddToLibraryMenu_viewer";
};
export type AddToLibraryMenu_viewer$key = {
  readonly " $data"?: AddToLibraryMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddToLibraryMenu_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddToLibraryMenu_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBotlessRecording",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionBillingCycleAnchor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountUploadCredits",
          "kind": "LinkedField",
          "name": "uploadCredits",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includedUploadCredits",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includedCreditsUsedCurrentCycle",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "featureFlag_useCopilotPaywallsOn_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventFormModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BillingIdentityFeaturesPaywall_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UploadMenuItem_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "592312d28ef243d5da97ae76ba825df8";

export default node;
